import { unionBy } from 'lodash';

import {
  getActionType,
  findOneAndUpdate,
} from 'modules/StaffDashboard/store/utils';

const initialState = {
  studentCount: 0,

  students: [],
  learningStyles: [],
  focusResults: [],
  careerGoals: [],
  careerClusters: [],
  futurePathways: [],
  favoritedSchools: [],
  popularMajors: [],
  studentToDos: [],

  onboardingItems: [],
  actions: [],
  indicators: [],
  analyticsStudentCount: {},

  // student indicators list
  studentIndicators: [],
  page: 0,
  count: 0,
  search: '',

  studentFeed: undefined,
  next: null,
};

// eslint-disable-next-line complexity
export default (state = initialState, action) => {
  switch (action.type) {
    case getActionType('populateStudentCount'):
      return {
        ...state,
        studentCount: action.studentCount,
      };

    case getActionType('populateStudents'):
      return {
        ...state,
        students: action.students,
      };

    case getActionType('populateLearningStyles'):
      return {
        ...state,
        learningStyles: action.learningStyles,
      };

    case getActionType('populateFocusResults'):
      return {
        ...state,
        focusResults: action.focusResults,
      };

    case getActionType('populateCareerGoals'):
      return {
        ...state,
        careerGoals: action.careerGoals,
      };

    case getActionType('populateCareerClusters'):
      return {
        ...state,
        careerClusters: action.careerClusters,
      };

    case getActionType('populateFuturePathways'):
      return {
        ...state,
        futurePathways: action.futurePathways,
      };

    case getActionType('populateFavoritedSchools'):
      return {
        ...state,
        favoritedSchools: action.favoritedSchools,
      };

    case getActionType('populatePopularMajors'):
      return {
        ...state,
        popularMajors: action.popularMajors,
      };

    case getActionType('populateStudentToDos'):
      return {
        ...state,
        studentToDos: action.studentToDos,
      };

    case getActionType('populateOnboardingItems'):
      return {
        ...state,
        onboardingItems: action.onboardingItems,
      };

    case getActionType('removeOnboardingItem'):
      return {
        ...state,
        onboardingItems: state.onboardingItems.filter(
          ({ key }) => key !== action.slug,
        ),
      };

    case getActionType('populateActions'):
      return {
        ...state,
        actions: action.actions,
      };

    case getActionType('populateIndicators'):
      return {
        ...state,
        indicators: action.indicators,
      };

    case getActionType('fullResetStudentIndicators'):
      return {
        ...state,
        studentIndicators: [],
        page: 0,
        count: 0,
        search: '',
      };

    case getActionType('resetStudentIndicatorsPage'):
      return {
        ...state,
        page: 0,
      };

    case getActionType('incPage'):
      return {
        ...state,
        page: state.page + 1,
      };

    case getActionType('mergeStudentIndicators'):
      return {
        ...state,
        studentIndicators: unionBy(
          state.studentIndicators,
          action.studentIndicators,
          'pk',
        ),
        count: action.count,
      };

    case getActionType('replaceStudentIndicators'):
      return {
        ...state,
        studentIndicators: action.studentIndicators,
        count: action.count,
      };

    case getActionType('setSearch'):
      return {
        ...state,
        search: action.search,
      };

    case getActionType('updateStudentIndicatorLocally'):
      return {
        ...state,
        studentIndicators: findOneAndUpdate(
          state.studentIndicators,
          'pk',
          action.id,
          action.update,
        ),
      };

    case getActionType('resetStudentFeed'):
      return {
        ...state,
        studentFeed: undefined,
      };

    case getActionType('incFeedPage'):
      return {
        ...state,
      };

    case getActionType('mergeStudentFeed'):
      return {
        ...state,
        studentFeed: unionBy(state.studentFeed || [], action.studentFeed, 'pk'),
        next: action.next,
      };

    default:
      return state;
  }
};
